import React from 'react'
import DataSource from '../DataSource'
import PageHOC from '../layout/PageHOC'
import MobileSq from '../components/MobileSq'
import BannerHome from '../banners/BannerHome'
import FeaturesHeading from '../components/FeaturesHeading'
import Awards from '../components/Awards'
import HighlightText from '../components/HighlightText'
import TrustPilotReviews from '../modules/TrustPilotReviews'
import globals from '../globals'

class Home extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            winner: {},
            features: []
        }
    }

    componentDidMount () {
        DataSource.getData('/api/home', result => {
            this.setState(result, this.props.animateIn)
        })
        globals.pushGA4Events("pageLoad", {
            eventInfo: {
                pageName: "Home Page",
                pageCategory: "Home page",
                pageType: "Information"
            }
        });
    }

    render () {
	    const FeaturesHeadingDesk = <React.Fragment>When it comes to<br /><HighlightText>broadband features,</HighlightText><br />we've got you covered</React.Fragment>
	    const FeaturesHeadingMob = <span>When it comes<br />to <HighlightText>broadband features</HighlightText>,<br />we've got you covered</span>

        return (
            <div className='homepage'>
                <BannerHome />
                <MobileSq />
                <div className='d-lg-none d-md-block'>
                    <TrustPilotReviews />
                </div>
                <FeaturesHeading headingDesktop={FeaturesHeadingDesk} headingMobile={FeaturesHeadingMob} features={this.state.features} />
            </div>
        )
    }
}

export default PageHOC(Home)



// WEBPACK FOOTER //
// ./resources/js/pages/Home.js